import React, { useContext } from "react";
import { Redirect } from "react-router";
import UserContext from "contexts/UserContext";

const Home = () => {
  const user = useContext(UserContext);

  if (user.isTeacher) {
    return <Redirect to="/students" />;
  }
  if (user.isAssistant) {
    return <Redirect to="/assistanthome" />;
  }
  if (user.isAdministrator) {
    return <Redirect to="/admin" />;
  }
  if (user.isParent) {
    return <Redirect to="/parenthome" />;
  }
  return null;
};

export default Home;
